import axios from "../axios";

const END_POINT = "/reception";

const oldReceptionsConsulates = (nationalCode) => axios.post(`${END_POINT}/old-receptions/reception-consulates/search`, nationalCode);
const oldReceptionsReferrals = (nationalCode) => axios.post(`${END_POINT}/old-receptions/reception-referrals/search`, nationalCode);
export {
    oldReceptionsConsulates,
    oldReceptionsReferrals

}